var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      © Breaze Delivery\n    ")])])
}]

export { render, staticRenderFns }